import type { components } from '@core/types/clients/game-session'

type WinData = components['schemas']['WinData']

/**
 * The monolith sends its own win payload on its own websocket keys; only game-session's
 * payload has these fields.
 */
export function isWinData(payload: unknown): payload is WinData {
    const win = payload as Partial<Record<keyof WinData, unknown>> | null | undefined

    return typeof win?.wonAt === 'string' && typeof win.userDisplayName === 'string' && typeof win.gameSlug === 'string'
}
